export async function waitUntil<T>(
  checkFn: () => Promise<T>,
  timeoutMs = 120_000,
  intervalMs = 2000
): Promise<T> {
  const start = Date.now();

  while (Date.now() - start < timeoutMs) {
    const result = await checkFn();

    if (result) {
      return result;
    }

    await new Promise((res) => setTimeout(res, intervalMs));
  }

  throw new TimeoutError(timeoutMs);
}

export class TimeoutError extends Error {
  constructor(timeoutMs: number) {
    super(`Timeout reached within ${timeoutMs / 1000} seconds`);
    this.name = "TimeoutError";
  }
}
